import React from "react";
// import { useNavigate } from "react-router-dom";

// Components
import Layout from "@/components/layout";

// Mui
// import Grid from "@mui/material/Grid";
// import Typography from "@mui/material/Typography";
// import Box from "@mui/material/Box";

// Mui Styles
// import { StyledPaper } from "@/styles/mui/globalStyles";

// import {
//   Chart as ChartJS,
//   ArcElement,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { Bar, Pie } from "react-chartjs-2";

// ChartJS.register(
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
//   ArcElement
// );

// const HorizontalBarOptions = {
//   responsive: true,
//   indexAxis: "y",
//   elements: {
//     bar: {
//       borderWidth: 2,
//     },
//   },
//   plugins: {
//     legend: {
//       position: "top",
//     },
//     title: {
//       display: false,
//       text: "Chart.js Bar Chart",
//     },
//   },
// };

// const VerticalBarOptions = {
//   responsive: true,
//   plugins: {
//     legend: {
//       position: "top",
//     },
//     title: {
//       display: false,
//       text: "Chart.js Bar Chart",
//     },
//   },
// };

// const labels = ["January", "February", "March"];

// const data = {
//   labels,
//   datasets: [
//     {
//       label: "Dataset 1",
//       data: labels.map(() => Math.random(1, 100)),
//       backgroundColor: "rgba(255, 99, 132, 0.5)",
//     },
//     {
//       label: "Dataset 2",
//       data: labels.map(() => Math.random(1, 100)),
//       backgroundColor: "rgba(53, 162, 235, 0.5)",
//     },
//   ],
// };

// const pieData = {
//   labels: ["Red", "Blue", "Yellow", "Green", "Purple", "Orange"],
//   datasets: [
//     {
//       label: "# of Votes",
//       data: [12, 19, 3, 5, 2, 3],
//       backgroundColor: [
//         "rgba(255, 99, 132, 0.2)",
//         "rgba(54, 162, 235, 0.2)",
//         "rgba(255, 206, 86, 0.2)",
//         "rgba(75, 192, 192, 0.2)",
//         "rgba(153, 102, 255, 0.2)",
//         "rgba(255, 159, 64, 0.2)",
//       ],
//       borderColor: [
//         "rgba(255, 99, 132, 1)",
//         "rgba(54, 162, 235, 1)",
//         "rgba(255, 206, 86, 1)",
//         "rgba(75, 192, 192, 1)",
//         "rgba(153, 102, 255, 1)",
//         "rgba(255, 159, 64, 1)",
//       ],
//       borderWidth: 1,
//     },
//   ],
// };
const MainPage = (props) => {
  const { open, setOpen } = props;
  // const navigate = useNavigate();
  return (
    <Layout header="Main Page" selectedIndex={1} open={open} setOpen={setOpen}>
      {/* <Grid container spacing={2}>
        <Grid item xs={3}>
          <StyledPaper page={"yes"}>
            <Box
              sx={{ display: "flex", width: "100%", flexDirection: "column" }}
            >
              <Typography
                variant="subtitle2"
                noWrap
                component="div"
                sx={{ fontWeight: 100 }}
              >
                淨利率
              </Typography>
              <Typography
                variant="h4"
                noWrap
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                86.66%
              </Typography>
            </Box>
          </StyledPaper>
        </Grid>

        <Grid item xs={3}>
          <StyledPaper page={"yes"}>
            <Box
              sx={{ display: "flex", width: "100%", flexDirection: "column" }}
            >
              <Typography
                variant="subtitle2"
                noWrap
                component="div"
                sx={{ fontWeight: 100 }}
              >
                單日最高銷售量
              </Typography>
              <Typography
                variant="h4"
                noWrap
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                $800,000
              </Typography>
            </Box>
          </StyledPaper>
        </Grid>
        <Grid item xs={3}>
          <StyledPaper page={"yes"}>
            <Box
              sx={{ display: "flex", width: "100%", flexDirection: "column" }}
            >
              <Typography
                variant="subtitle2"
                noWrap
                component="div"
                sx={{ fontWeight: 100 }}
              >
                最受迎的特賣點
              </Typography>
              <Typography
                variant="h4"
                noWrap
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                荃灣分店
              </Typography>
            </Box>
          </StyledPaper>
        </Grid>
        <Grid item xs={3}>
          <StyledPaper page={"yes"}>
            <Box
              sx={{ display: "flex", width: "100%", flexDirection: "column" }}
            >
              <Typography
                variant="subtitle2"
                noWrap
                component="div"
                sx={{ fontWeight: 100 }}
              >
                最佳銷售員
              </Typography>
              <Typography
                variant="h4"
                noWrap
                component="div"
                sx={{ fontWeight: "bold" }}
              >
                陳大明
              </Typography>
            </Box>
          </StyledPaper>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <StyledPaper page={"yes"}>
            <Bar options={HorizontalBarOptions} data={data} />
          </StyledPaper>
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <StyledPaper page={"yes"}>
            <Bar options={VerticalBarOptions} data={data} />
          </StyledPaper>
        </Grid>
        <Grid item xs={4}>
          <StyledPaper page={"yes"}>
            <Pie data={pieData} />
          </StyledPaper>
        </Grid>
      </Grid> */}
    </Layout>
  );
};

export default MainPage;
